import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { withApollo } from "react-apollo";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import RefreshIcon from "@material-ui/icons/Refresh";
import Tooltip from "@material-ui/core/Tooltip";
import { numberWithCommas } from "js/utils";

import { styles } from "js/pages/Admin/Programa/Notificaciones/Table/styles.js";

class SimpleTable extends PureComponent {
  render() {
    const {
      classes,
      history,
      rows,
      idPrograma,
      hasBOAccess,
      onRegenerar,
      regenerating
    } = this.props;
    const isAdminPage = idPrograma === 1;
    return (
      <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell className={cx(classes.columnWidth100, classes.border)}>
                Nombre
              </TableCell>
              <TableCell className={cx(classes.columnWidth300)}>
                Asunto del email
              </TableCell>
              <TableCell numeric className={cx(classes.columnWidth80)}>
                Puntos a acreditar
              </TableCell>
              <TableCell className={cx(classes.columnWidth80)}>
                Estado
              </TableCell>
              <TableCell className={cx(classes.columnWidth150)}>
                Acción
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => {
              return (
                <TableRow key={row.idNotificacion}>
                  <TableCell
                    component="th"
                    scope="row"
                    className={cx(classes.columnWidth100, classes.border)}
                  >
                    {row.nombre}
                  </TableCell>
                  <TableCell className={cx(classes.columnWidth300)}>
                    {row.asunto}
                  </TableCell>
                  <TableCell numeric className={cx(classes.columnWidth80)}>
                    {row.puntos ? numberWithCommas(row.puntos) : "--"}
                  </TableCell>
                  <TableCell className={cx(classes.columnWidth80)}>
                    {row.estado}
                  </TableCell>
                  <TableCell className={cx(classes.columnWidth150)}>
                    <IconButton
                      aria-label="Editar"
                      onClick={e =>
                        history.push(
                          window.location.pathname +
                            "/" +
                            row.idNotificacion +
                            "/edit"
                        )
                      }
                    >
                      <EditIcon />
                    </IconButton>
                    {hasBOAccess &&
                      isAdminPage && (
                        <Tooltip title="Regenerar en programas faltantes">
                          <IconButton
                            aria-label="Regenerar"
                            onClick={() => onRegenerar(row.idNotificacion)}
                            disabled={regenerating !== null}
                          >
                            <RefreshIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Paper>
    );
  }
}

SimpleTable.propTypes = {
  classes: PropTypes.object.isRequired,
  idPrograma: PropTypes.number,
  hasBOAccess: PropTypes.bool,
  onRegenerar: PropTypes.func,
  regenerating: PropTypes.number
};

export default withApollo(withRouter(withStyles(styles)(SimpleTable)));
